import { TValidTestId } from 'types/context-role-element.types';
import { CONTEXT, ELEMENT, ROLE } from '../context-role-element';

export default {
  [CONTEXT.SECTION_BLOG]: {
    [ROLE.LINK]: [ELEMENT.CARD, ELEMENT.HEADER],
    [ROLE.CONTAINER]: [ELEMENT.HEADER, ELEMENT.SKELETON],
  },
} as TValidTestId;
